module.exports = __webpack_public_path__ + "img/IMG_9432_L_BlackMatted_MockedUp.04e38210.jpg";